import React, { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import Homework from "../../../../components/Homework";
import { useApi } from "../../../../context/api.js";
import MDBox from "../../../../components/MDBox";
import brandWhite from "../../../../assets/images/logo-ct.png";
import MDAvatar from "../../../../components/MDAvatar";
import MDTypography from "../../../../components/MDTypography";

function ParentHomework() {
  const api = useApi();

  const [menu, setMenu] = useState(null);
  const [children, setChildren] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);

  useEffect(() => {
    api.getChildren().then((res) => {
      setChildren(res || []);
      if (res && res.length) {
        const childId = localStorage.getItem("lastSelectedChild");
        setSelectedChild(res.find((c) => c.id === childId) || res[0]);
      }
    });
  }, []);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);

  const selectChild = (child) => {
    // Save for next refresh
    localStorage.setItem("lastSelectedChild", child.id);

    setSelectedChild(child);

    setMenu(null);
  };

  const renderMenu = () => (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      {(children || []).map((c) => (
        <MenuItem key={c.id} onClick={() => selectChild(c)} selected={selectedChild === c.id}>
          <MDAvatar
            src={c.picture ? "/files/profile/" + c.picture : brandWhite}
            alt="profile-image"
            size="xs"
            shadow="sm"
          />
          <span style={{ marginLeft: 8 }}>{c.name}</span>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <Card>
      {children === null && (
        <MDBox
          sx={{ minHeight: 200, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <CircularProgress color="info" size={42} />
        </MDBox>
      )}
      {children !== null && !children.length && (
        <>
          <MDTypography>Vous n&apos;avez pas d&apos;enfant associé à votre compte.</MDTypography>
          <MDTypography variant="button">
            Cliquez ici pour voir comment associer un enfant.
          </MDTypography>
        </>
      )}
      {children !== null && children.length && (
        <>
          <Homework
            title={"Devoirs à faire pour " + selectedChild.name}
            additionalActions={
              children.length > 1 ? (
                <Icon
                  key="menu"
                  sx={{ cursor: "pointer", fontWeight: "bold", ml: 1 }}
                  fontSize="medium"
                  onClick={openMenu}
                >
                  more_vert
                </Icon>
              ) : undefined
            }
            showAdd
            userId={selectedChild.id}
          />
          {children.length > 1 && renderMenu()}
        </>
      )}
    </Card>
  );
}

export default ParentHomework;
